import { Box, Dialog, IconButton, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material'
import { Icons } from '../../../utils/utilities'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import React, { useCallback, useEffect } from 'react'
import { useState } from 'react'
import { useLiveSessionStore } from '../../../store/livesessions.store'
import { DescriptionOutlined, Link, Movie, } from '@mui/icons-material'


const typeIcons = {
    'document': Icons.default.DescriptionIcon,
    'video': Icons.default.Movie,
    'link': Icons.default.Link
}


const AuditClassSessionViewer = ( { handleClose, openState, classSession } ) => {

    const [resources, setResources] = useState( [] )
    const [fetchingResources, setFetchingResources] = useState( {} )
    const [resourcesFetchError, setResourcesFetchError] = useState( false )

    const { palette, border, layout } = useTheme()

    const LiveSessionStore = useLiveSessionStore()


    const fetchQuestions = useCallback( async () => {
        setFetchingResources( true )
        try {
            setResourcesFetchError( null )
            await LiveSessionStore.fetchLiveSession( classSession.id )
            setResources( LiveSessionStore.getLiveSession?.resources || [] )
        } catch ( err ) {
            console.log( err )
            setResourcesFetchError( err?.response?.data?.message || "Opps! An error occured while trying to fetchquiz resources try again." )
        } finally {
            setFetchingResources( false )
        }
    }, [classSession, LiveSessionStore] )

    useEffect( () => {
        fetchQuestions()
    }, [fetchQuestions] )

    return (
        <Dialog open={openState} slotProps={{
            paper: { sx: { width: "90%", maxWidth: "1200px", display: "flex", flexDirection: "column" } }
        }}>
            <Box sx={{ zIndex: 10 }} position="static" borderBottom={border[1]} top="0" bgcolor={palette.background.paper} display="flex" alignItems="center" justifyContent="space-between" padding="20px" >
                <Box>
                    <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">{classSession.name}</Typography>
                    <Typography variant="subtitle2" fontSize="12px" color='textSecondary' >Resources: {resources.length}</Typography>
                </Box>
                <IconButton onClick={handleClose}>{Icons.default.CloseIcon}</IconButton>
            </Box>
            {!fetchingResources && resources.length > 0 && <Box padding="20px" display="grid" gridTemplateColumns={{ lg: "1fr 1fr 1fr 1fr", md: "1fr 1fr 1fr", sm: "1fr 1fr", xs: "1fr" }} gap={layout.cardsGap} >
                {resources.map( resource => (
                    <Box height="200px" overflow="hidden" borderRadius={layout.borderRadius} border={border[1]} display="flex" flexDirection="column" sx={{ ":hover": { borderColor: palette.common.font, cursor: "pointer" } }} >
                        <Box fontSize="64px" flexGrow={1} sx={{ overflow: "hidden" }} display="flex" alignItems="center" justifyContent="center">
                            {resource?.resource_metadata?.resource?.image ?
                                <Box component="img" maxHeight="100%" style={{ objectFit: "contain" }} maxWidth="100%" src={resource?.resource_metadata?.resource?.image} alt={resource?.name} /> :
                                typeIcons[resource.resource_type]
                            }
                        </Box>
                        <Box alignItems="center" fontSize="32px" gap="10px" overflow="hidden" display="flex" padding="10px">
                            {typeIcons[resource.resource_type]}
                            <Box flexGrow={1} minWidth="0" overflow="hidden">
                                <Typography variant='subtitle2' fontSize="14px" display="block" width="100%" noWrap>{resource.name}</Typography>
                                <Typography variant='subtitle2' display="block" fontSize="12px" noWrap>{resource.resource_type}</Typography>
                            </Box>
                        </Box>
                    </Box>
                ) )}
            </Box>}
            <Box padding="20px">
                {resources.length === 0 && <Typography textAlign="center" padding="50px 20px" variant='subtitle2' color="textSecondary">No Resources to show!</Typography>}
                {resourcesFetchError && <Typography padding="20px" color="errorMessage.main" variant='subtitle2'>{resourcesFetchError}</Typography>}
            </Box>
            {fetchingResources && <DataLoadingSpinner waitingMessage="Loading the classSession resources please wait..." />}
        </Dialog>
    )
}

export default AuditClassSessionViewer
